class l extends Error {
  status;
  code;
  requestId;
  fieldErrors;
  constructor(t, e) {
    super(e.message || e.code), this.name = "ApiError", this.status = t, this.code = e.code, this.requestId = e.request_id, this.fieldErrors = e.field_errors ?? {};
  }
}
function h(a, t, e) {
  const r = `${a.replace(/\/$/, "")}${t.startsWith("/") ? t : `/${t}`}`;
  if (!e) return r;
  const i = new URLSearchParams();
  for (const [n, c] of Object.entries(e))
    c !== void 0 && i.append(n, String(c));
  const o = i.toString();
  return o ? `${r}?${o}` : r;
}
class y {
  constructor(t) {
    this.config = t;
  }
  async request(t, e = {}) {
    const r = this.config.fetchImpl ?? fetch, i = h(this.config.baseUrl, t, e.query), o = {
      Accept: e.accept ?? "application/json",
      ...e.headers
    };
    let n;
    e.body !== void 0 && (e.body instanceof FormData || e.body instanceof Blob || e.body instanceof ArrayBuffer || typeof e.body == "string" ? n = e.body : (o["Content-Type"] ??= "application/json", n = JSON.stringify(e.body))), e.idempotencyKey && (o["Idempotency-Key"] = e.idempotencyKey);
    const c = {
      method: e.method ?? "GET",
      credentials: "include",
      headers: o
    };
    n !== void 0 && (c.body = n), e.signal && (c.signal = e.signal);
    const s = await r(i, c);
    if (s.status === 204)
      return;
    const d = s.headers.get("content-type") ?? "";
    if (!s.ok) {
      let u = {
        code: "INTERNAL_ERROR",
        message: s.statusText,
        field_errors: {},
        request_id: s.headers.get("x-request-id") ?? ""
      };
      if (d.includes("application/json"))
        try {
          const f = await s.json();
          f.error && (u = f.error);
        } catch {
        }
      throw s.status === 401 && this.config.onUnauthenticated?.(), new l(s.status, u);
    }
    return d.includes("application/json") ? await s.json() : await s.text();
  }
  get(t, e) {
    return this.request(t, { ...e, method: "GET" });
  }
  post(t, e, r) {
    return this.request(t, { ...r, method: "POST", body: e });
  }
  put(t, e, r) {
    return this.request(t, { ...r, method: "PUT", body: e });
  }
  patch(t, e, r) {
    return this.request(t, { ...r, method: "PATCH", body: e });
  }
  delete(t, e) {
    return this.request(t, { ...e, method: "DELETE" });
  }
  /**
   * Subscribe to a server-sent-events stream at `path`. EventSource does
   * not support custom headers, so the cookie is still attached via
   * browser-native credentials behaviour when the endpoint is same-site.
   */
  subscribeSse(t, e) {
    const r = h(this.config.baseUrl, t), i = new EventSource(r, { withCredentials: !0 });
    return i.onmessage = e.onMessage, e.onError && (i.onerror = e.onError), () => i.close();
  }
}
export {
  y as ApiClient,
  l as ApiError
};
//# sourceMappingURL=client.js.map
